import React, { useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import cn from 'classnames'
import classes from './SchoolNoteSchoolForm.module.sass'
import Select from 'react-select'

const NoteField = ({ note }) => {
  const [_, setDummy] = useState()

  const handleChange = (attr, value) => {
    note[attr] = value
    setDummy(value)
  }

  const handleRemoval = (event) => {
    note.isMarkedForDestruction = event.target.checked
  }

  return (
    <div>
      Note
      <label className={classes.label}>
        Follow Up Date
        <KeyboardDatePicker
          autoOk
          className={classes.dateInput}
          disableToolbar
          variant="inline"
          format="MM/dd/yyyy"
          margin="dense"
          value={note.createdAt}
          onChange={(date) => handleChange('createdAt', date)}
        />
      </label>
      <div className={classes.mt}>
        <label className={classes.label}>
          Priority
          <Select
            isSearchable={false}
            value={{ value: note.priority, label: note.priority.toString() }}
            onChange={(opt) => handleChange('priority', opt.value)}
            options={[
              { value: 1, label: '1' },
              { value: 2, label: '2' },
              { value: 3, label: '3' },
              { value: 4, label: '4' },
              { value: 5, label: '5' },
              { value: 6, label: '6' },
              { value: 7, label: '7' },
              { value: 8, label: '8' },
              { value: 9, label: '9' },
              { value: 10, label: '10' },
            ]}
          />
        </label>
      </div>
      <div className={classes.mt}>
        <textarea
          onChange={(e) => handleChange('note', e.target.value)}
          className={cn(classes.input, classes.textarea)}
          value={note.note}
        />
      </div>
      <div className={classes.removeCheckboxContainer}>
        <label>Remove</label>
        <input type="checkbox" onChange={handleRemoval} />
      </div>
    </div>
  )
}

export default NoteField
